import http from "./http";

/**
 * Service for the bulk "Marcar como Preparado" action (Trello #416).
 *
 * Uses the central http instance — no raw axios, no module-scope token reads.
 */
const PedidosPrepararService = {
  /**
   * Moves each given pedido from estado 4 (En facturación) to 7 (Preparado),
   * discounting stock exactly as the "Confirmar" flow does. Not atomic:
   * some orders can move while others do not (see response.omitidos/fallidos).
   * @param {number[]} pedidos - Array of id_pedido to mark as prepared (batches capped at 200 by the backend)
   * @returns {Promise} Axios response; response.data = { title, msg, type, movidos, omitidos, fallidos }
   */
  marcarPreparado(pedidos) {
    return http.post("pedidos/preparar", { pedidos });
  },
};

export default PedidosPrepararService;
